module.exports = __webpack_public_path__ + "img/elektronika.827dba4a.svg";